import { useEffect, Dispatch, SetStateAction } from 'react'
import { useSelector } from 'store/store'
import { useParams } from 'react-router-dom'
import { Container, LoadingHavaianas } from 'components'
import { RequestMaterialsInterface } from 'container/SalesOrder/interfaces'

import Insert from './Insert'
import MaterialsList from './List'
import UploadMaterials from '../UploadMaterials'

import {
  RowColumnTableItemsOrderStyled,
  ContentDivider,
  LoadingContainer
} from './styles'

export interface MaterialsProps {
  hasCustommer: boolean
  handleRequestMaterials: () => void
  requestMaterials: RequestMaterialsInterface
  setModalMaterialsLimit: Dispatch<SetStateAction<boolean>>
  user: string
  hasUnsavedOVConfig: boolean
  handleFieldModified: () => void
}
const Materials: React.FC<MaterialsProps> = ({
  hasCustommer,
  handleRequestMaterials,
  requestMaterials,
  setModalMaterialsLimit,
  user,
  hasUnsavedOVConfig,
  handleFieldModified
}) => {
  const { orderNumber } = useParams()
  const {
    loadingMaterials: loading,
    emptyData,
    materialSearch,
    materialsLimitExceed
  } = useSelector((state) => state.salesOrder)
  const { isHAVAConectaOrder } = useSelector((state) => state.ov)

  useEffect(() => {
    setModalMaterialsLimit(materialsLimitExceed)
  }, [materialsLimitExceed])

  return (
    <Container fullwidth={true}>
      <Insert
        user={user}
        hasUnsavedOVConfig={hasUnsavedOVConfig}
        hasOrderNumber={!!orderNumber}
      />

      {!!orderNumber && (
        <>
          <ContentDivider />
          {loading ? (
            <LoadingContainer>
              <LoadingHavaianas />
            </LoadingContainer>
          ) : (
            <>
              {emptyData && !materialSearch ? (
                <UploadMaterials disabled={isHAVAConectaOrder} />
              ) : (
                <RowColumnTableItemsOrderStyled>
                  <MaterialsList
                    user={user}
                    hasCustommer={hasCustommer}
                    handleRequestMaterials={handleRequestMaterials}
                    requestMaterials={requestMaterials}
                    handleFieldModified={handleFieldModified}
                  />
                </RowColumnTableItemsOrderStyled>
              )}
            </>
          )}
        </>
      )}
    </Container>
  )
}

export default Materials
